export const HOTELS_MAP_TEXTS = {
  priceFrom: 'от',
  priceEmpty: '—',
  listButton: 'Списком',
  reviewsEmpty: 'Нет отзывов',
  locationJoin: ', ',
  photoAlt: 'Фото отеля',
  closeCard: 'Закрыть',
  loadError: 'Не удалось загрузить карту',
  emptyState: 'У найденных отелей нет координат для карты',
  clusterTitle: 'Отели в этой точке',
} as const;

export const REVIEWS_PLURAL_FORMS = ['отзыв', 'отзыва', 'отзывов'];
